import api from "../api";

class OrderService {
    formatDate(date) {
        if (date == null || date === "") {
            return "";
        }
        return new Intl.DateTimeFormat("en-US", {
            year: "2-digit",
            month: "2-digit",
            day: "2-digit",
        }).format(date);
    }

    GetFormattedDate(date) {
        if (date == null || date === "") {
            return "";
        }

        let month = date.getMonth() + 1,
            day = date.getDate(),
            year = date.getFullYear();

        return month + "/" + day + "/" + year;
    }

    async getAllOrders(filters) {
        return new Promise((res, reject) => {
            if (filters) {
                filters.startDate = this.GetFormattedDate(filters.startDate);
                filters.endDate = this.GetFormattedDate(filters.endDate);
            }

            api.get("/findOrdersByStatuses", filters)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getOrdersWithLocations(filters) {
        return new Promise((res, reject) => {
            let params = {
                statuses: filters.statuses || [],
                reasonIds: filters.reasonIds || [],
                equipmentIds: filters.equipmentIds || [],
                internalLocations: filters.internalLocations || [],
                clinicLocations: filters.seatingClinics || [],
                salesOrService: filters.salesOrService || "Sales",
                startDate: this.GetFormattedDate(filters.startDate) || "",
                endDate: this.GetFormattedDate(filters.endDate) || "",
                DOB: this.GetFormattedDate(filters.dob) || "",
                q: filters.searchText || "",
                pageSize: filters.pageSize || 150,
            };
            api.get("/findOrdersWithLocations", params)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getOrderActivity(id) {
        return new Promise((res, rej) => {
            api.get("/order?id=" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej();
                });
        });
    }

    async getFlatOrderActivity(id) {
        return new Promise((res, rej) => {
            api.get("/orderFlat?id=" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej();
                });
        });
    }

    getOrderProducts(id) {
        return new Promise((res, rej) => {
            api
                .get("/orders/getOrderProducts/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej();
                });
        });
    }

    updateOrderProducts(id, prods) {
        return new Promise((res, rej) => {
            api
                .put("/orders/updateOrderProducts/" + id, prods)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej();
                });
        });
    }

    removeOrderProduct(id) {
        return new Promise((res, rej) => {
            api
                .post("/orders/removeOrderProduct/" + id) // id of the item to be removed
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej();
                });
        });
    }

    createPreAuth(id) {
        return new Promise((res, rej) => {
            api
                .post("/orders/createPreauth/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej();
                });
        })
    }

    getCurrentlyWorkingByOrder(id) {
        return new Promise((res, rej) => {
            api
                .get("/getCurrentlyWorkingOrder/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej();
                });
        });
    }

    async syncToBrightTree(id) {
        return new Promise((res, rej) => {
            api.post("/syncToBrightTree/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej();
                });
        });
    }

    // calls proc spGetTechTimeline
    async getDeliveriesForLocation(locationId) {
        return new Promise((res, reject) => {
            api.get("/orders/deliveries/" + locationId)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async updateDelivery(order) {
        return new Promise((res, reject) => {
            api.put("/orders/deliveriesUpdate", order)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getTechDeliveryTimeline(locationId, startDate, endDate) {
        return new Promise((res, reject) => {
            let params = {
                startDate: startDate,
                endDate: endDate,
            };
            api.get("/getTechTimeline/" + locationId, params)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getOrdersWithLocationsNoDeliveryDate(filters) {
        return new Promise((res, reject) => {
            let params = {
                statuses: filters.statuses || "",
                internalLocations: filters.internalLocations || [],
                startDate: this.GetFormattedDate(filters.startDate) || "",
                endDate: this.GetFormattedDate(filters.endDate) || "",
                noScheduledDate: "true",
                q: filters.q,
                pageSize: filters.pageSize || 100,
            };
            api.get("/findOrdersWithLocationsNoScheduledDate", params)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getOrdersWithLocationsDeliveryDate(filters) {
        return new Promise((res, reject) => {
            let params = {
                statuses: filters.statuses || "",
                internalLocations: filters.internalLocations || [],
                startDate: filters.deliveryDateStart || "",
                endDate: filters.deliveryDateEnd || "",
                noScheduledDate: "true",
                users: filters.users || [],
                pageSize: filters.pageSize || 150,
            };
            api.get("/findDeliveries", params)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async searchOrders(filters) {
        return new Promise((res, reject) => {
            if (filters) {
                filters.startDate = this.GetFormattedDate(filters.startDate);
                filters.endDate = this.GetFormattedDate(filters.endDate);
            }

            api.get("/searchOrdersByStatuses", filters)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    // calls proc spGetDashboardCounts
    async getDashboardCounts() {
        return new Promise((res, reject) => {
            api.get("/dashboard", null)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    // calls proc spGetOrderListing
    async getAllOrdersNative(filters) {
        return new Promise((res, reject) => {
            api.get("/orderListing", filters)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    // calls proc spGetOrderById
    async getOrdersByIdNative(filters) {
        return new Promise((res, reject) => {
            api.get("/orderByIdNative", filters)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    // calls proc spInsuranceVerificationView
    async getInsuranceVerificationViewNative(id) {
        return new Promise((res, reject) => {
            api.get("/verificationView?id=" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    // calls proc inProcessQueue
    async getInProcessView(regionId, reasonId) {
        return new Promise((res, reject) => {
            api.get("/inProcessView/" + reasonId + (regionId ? "?regionId=" + regionId : ""))
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    // calls proc spBillingView
    async getBillingViewNative(filters) {
        return new Promise((res, reject) => {
            api.get("/billingView", filters)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }


    async getServiceDocFollowUpNative(id) {
        return new Promise((res, reject) => {
            api
                .get("/orders/sdfuOrders/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    // calls proc spInternalRequest
    async getInternalRequestViewNative(filters) {
        return new Promise((res, reject) => {
            api.get("/internalRequest", filters)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    // calls proc spGetFollowupView
    async getFollowUpViewNative(id) {
        return new Promise((res, reject) => {
            api.get("/followupView?id=" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    // calls proc spGetATPView
    async getATPViewNative(filters) {
        return new Promise((res, reject) => {
            api.get("/atpView", filters)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    // calls proc spCollectionsView
    async getCollectionsViewNative(filters) {
        return new Promise((res, reject) => {
            api.get("/collectionsView", filters)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getActivity(id) {
        return new Promise((res, reject) => {
            api.get("/activities/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getApprovalsByOrder(orderId) {
        return new Promise((res, reject) => {
            api.get("/approvalByOrder/" + orderId)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                })
        })
    }

    async updateApprovalByOrder(obj) {
        return new Promise((res, reject) => {
            api.put("/approval", obj)
                .then((data) => {
                    res(data)
                })
                .catch((err) => {
                    reject();
                })
        })
    }

    async createOrder(order) {
        return new Promise((res, reject) => {
            api.post("/activities", order)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    //could be {data: order}
    async updateOrder(order) {
        return new Promise((res, reject) => {
            return api
                .put("/orders/update", order)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async updateFlatOrder(order) {
        return new Promise((res, reject) => {
            return api
                .put("/orders/updateFlat", order)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async updateOrderProperties(id, orderData) {
        return new Promise((res, reject) => {
            return api
                .post("/orders/updateOrderProperties/" + id, orderData)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async clearBeingWorkedBy(orderId) {
        return new Promise((res, rej) => {
            return api
                .post("/orders/clearBeingWorkedBy/" + orderId)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej();
                });
        });
    }

    async setBeingWorkedBy(orderId) {
        return new Promise((res, rej) => {
            return api.post("/orders/setBeingWorkedBy/" + orderId)
                .then(data => {
                    res(data);
                })
                .catch(err => {
                    rej();
                });
        });
    }

    async uploadDocument(order, file, fileName, userId) {
        return new Promise((res, reject) => {
            return api
                .downloadPost("/activities/" + order.id + "/files/" + fileName + "/" + userId, file)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async uploadDocumentWithStamp(order, file, fileName, userId) {
        return new Promise((res, reject) => {
            return api
                .downloadPost(
                    "/activities/" + order.id + "/fileswithstamp/" + fileName + "/" + userId,
                    file
                )
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getDocumentThumbnails(docId) {
        return new Promise((res, reject) => {
            return api
                .get("/deliveryPaperwork/image/" + docId)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async downloadDocument(orderId, fileName, userId, file) {
        return new Promise((res, reject) => {
            return api.downloadPost("/api/activities/" + orderId + "/files/" + fileName + "/" + userId, file)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async downloadDoc(id) {
        return new Promise((res, reject) => {
            return api
                .getFile("/files/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async deleteDocument(id) {
        return new Promise((res, reject) => {
            return api
                .delete("/files/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getOrderTimeline(order) {
        return new Promise((res, reject) => {
            return api
                .get("/orders/orderHistory/" + order.id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getOrdersByAccount(id) {
        return new Promise((res, reject) => {
            let params = {
                page: 0,
                size: 25,
            },
                url = "/accounts/" + id + "/orders";

            return api
                .get(url, params)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getOrderAttachments(id) {
        return new Promise((res, reject) => {
            return api
                .get("/activity/files/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getPatients() {
        return new Promise((res, reject) => {
            return api
                .get("/patients")
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getPatientById(patientId) {
        return new Promise((res, reject) => {
            return api
                .get("/patient?id=" + patientId)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getPatientByIdFromOtherCompany(patientId, params, credentials) {
        return new Promise((res, reject) => {
            return api
                .getFromOtherCompany("/patients/" + patientId, params, credentials)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getPatientOrdersById(patientId) {
        return new Promise((res, reject) => {
            return api
                .get("/patientOrders/" + patientId)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    // calls proc spGetPatientList
    async getPatientsByInformation(fName, lName, dob, phone) {
        let params = {
            firstname: fName || "",
            lastname: lName || "",
            birthDate: dob || "",
            phone: phone || "",
        };
        return new Promise((res, reject) => {
            return api
                .get("/patients", params)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async updatePatient(data) {
        return new Promise((res, reject) => {
            return api
                .put("/patient", data)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async createPatient(data) {
        return new Promise((res, reject) => {
            return api
                .post("/patient", data)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    // calls proc spMergePatients
    async mergePatients(params) {
        return new Promise((res, reject) => {
            return api
                .get("/mergePatients", params)
                .then(() => {
                    res();
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async mergeDocuments(order, fileIds) {
        return new Promise((res, reject) => {
            return api
                .post("/activities/" + order.id + "/merge", fileIds)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async mergePagedDocuments(order, files, name, userId) {
        return new Promise((res, reject) => {
            return api
                .post("/activities/" + order.id + "/mergepages/" + name + "/" + userId, files)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    // calls proc spGetDeliveryAverages
    async getDashboardDeliveryAverages(props) {
        let params = null;

        if (props != null) {
            params = {id: props};
        }

        return new Promise((res, reject) => {
            api.get("/deliveryAverages", params)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getUserQuotaMetrics(id) {
        let params = {
            id: id,
        };

        return new Promise((res, reject) => {
            api.get("/dashboard/quotaMetrics", params)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getAllOrderFrequency() {
        return new Promise((res, reject) => {
            api.get("/recurringOrders")
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getOrderFrequency(id) {
        return new Promise((res, reject) => {
            api.get("/orders/recurringOrders/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async createOrderFrequency(data) {
        return new Promise((res, reject) => {
            return api
                .post("/orders/recurringOrders", data)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async updateOrderFrequency(data) {
        return new Promise((res, reject) => {
            return api
                .put("/orders/recurringOrders", data)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getOrderListing(filters) {
        return new Promise((res, reject) => {
            return api
                .get("/orderListing", filters)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async syncOrderWithBT(id) {
        return new Promise((res, reject) => {
            return api
                .post("/orders/syncToBt/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getBtProducts(hcpcs) {
        return new Promise((res, reject) => {
            return api
                .get("/btproducts/" + hcpcs)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getServiceOrderReason(id) {
        return new Promise((res, rej) => {
            return api
                .get("/orders/serviceOrderReasonByCurrent/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej(err);
                });
        });
    }

    async buildPaSummary(items) {
        return new Promise((res, reject) => {
            return api
                .post("/buildPaSummary", items)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getPatientLastChartNotes(id) {
        return new Promise((res, rej) => {
            return api
                .get("/patientChartNoteMeta/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej(err);
                });
        });
    }

    async getPipelineView(id) {
        return new Promise((res, rej) => {
            return api
                .get("/pipelineView" + (id ? "?regionId=" + id : ""))
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej(err);
                });
        });
    }

    async getPaymentsCollected(filters) {
        return new Promise((res, reject) => {
            api
                .get("/getPaymentsCollected", filters)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

}

const orderService = new OrderService();

export default orderService;
